import { __decorate } from "tslib";
import { html, nothing } from 'lit';
import { CipublicElement } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/mixins/base.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { property } from 'lit/decorators.js';
import { InternalI18n } from '@cigna/cigna_csg_gsg_cipublic-shared/lib/i18n/internal-i18n-controller.js';
import styles from './fieldset.scss.js';
/**
 * @param Base The base class.
 *
 * @returns fieldset component.
 *
 * @slot - form elements
 */
export class Fieldset extends CipublicElement {
    constructor() {
        super(...arguments);
        this.i18n = new InternalI18n(this);
        /**
         * Indicate if the group is disabled. Defaults to `false`.
         */
        this.disabled = false;
        /**
         * Optional Text.
         */
        this.optional = this.i18n.t('optional');
        /**
         * Indicate to the screen reader if the group is required. Defaults to `false`.
         *
         * Note: `required` is still needed on individual form elements/groups.
         */
        this.required = 'false';
        /**
         * Indicate if the fieldset/legend styles should be reset.
         */
        this.variant = 'default';
    }
    static get styles() {
        return [styles];
    }
    updated(changedProperties) {
        super.updated(changedProperties);
        if (changedProperties.has('disabled') || changedProperties.has('required')) {
            if (this.disabled || this.required) {
                // should we find a different way to get form elements, how is performance?
                this.querySelectorAll('*').forEach((element) => {
                    var _a, _b;
                    if (element.tagName.includes('-')) {
                        (_b = (_a = element).requestUpdate) === null || _b === void 0 ? void 0 : _b.call(_a);
                    }
                });
            }
        }
    }
    render() {
        const { disabled, label, optional, required } = this;
        return html `<fieldset aria-required="${ifDefined(required)}" ?disabled="${disabled}"><legend>${label} ${required === 'false' ? optional : nothing}</legend><slot></slot></fieldset>`;
    }
}
__decorate([
    property({ reflect: true, type: Boolean })
], Fieldset.prototype, "disabled", void 0);
__decorate([
    property({ reflect: true })
], Fieldset.prototype, "label", void 0);
__decorate([
    property({ reflect: true })
], Fieldset.prototype, "optional", void 0);
__decorate([
    property({ reflect: true, attribute: 'aria-required' })
], Fieldset.prototype, "required", void 0);
__decorate([
    property({ reflect: true })
], Fieldset.prototype, "variant", void 0);
//# sourceMappingURL=fieldset.js.map